import { Component } from '@angular/core';

@Component({
  selector: 'app-loader-stub',
  templateUrl: 'loader-stub.html',
  styleUrls: ['loader-stub.scss'],
})
export class LoaderStubComponent {
}
